module.exports = __webpack_public_path__ + "img/6.149c2f7.png";